<script>
// https://wlada.github.io/vue-carousel-3d/guide/
import { Carousel3d, Slide } from 'vue-carousel-3d'

export default {
    name: 'dkbr-figure',
    components: {Carousel3d, Slide},
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        isShow: {
            name: 'isShow',
            type: Boolean,
            txtDescr: `Image(s) will be removed if false`,
            default: _ => true,
        },
        src: {
            name: 'src',
            type: String,
            txtDescr: `Image source`,
            default: _ => '',
        },
        srcs: {
            name: 'srcs',
            type: Array,
            txtDescr: `Image sources (carousel will be used if given)`,
            default: _ => [],
        },
        alt: {
            name: 'alt',
            type: String,
            txtDescr: `Alt text for image`,
            default: _ => '',
        },
        txt: {
            name: 'txt',
            type: String,
            txtDescr: `Caption for the image`,
            default: _ => '',
        },
        is3D: {
            name: 'is3D',
            type: Boolean,
            txtDescr: `If true, 3D carousel is used`,
            default: _ => true,
        },
        isRepeat: {
            name: 'isRepeat',
            type: Boolean,
            txtDescr: `Enable carousel infinite loop`,
            default: _ => true,
        },
        isAuto: {
            name: 'isAuto',
            type: Boolean,
            txtDescr: `Flag to enable autoplay`,
            default: _ => false,
        },
        isArrows: {
            name: 'isArrows',
            type: Boolean,
            txtDescr: `Show controls (left/right arrow)`,
            default: _ => false,
        },
        isClick: {
            name: 'isClick',
            type: Boolean,
            txtDescr: `Enable navigation by clicking on slide`,
            default: _ => true,
        },
        autoPauseH: {
            name: 'autoPauseH',
            type: Boolean,
            txtDescr: `TFlag to pause autoplay on hover`,
            txtEnable: 'Can be used only if "isAuto"',
            enabled: (v, sett) => sett.isAuto,
            default: _ => true,
        },
        autoDt: {
            name: 'autoDt',
            type: Number,
            txtDescr: `Time elapsed before advancing slide`,
            txtEnable: 'Can be used only if "isAuto"',
            enabled: (v, sett) => sett.isAuto,
            default: _ => 5000,
        },
        animDt: {
            name: 'animDt',
            type: Number,
            txtDescr: `Animation between slides in milliseconds`,
            default: _ => 500,
        },
        count: {
            name: 'count',
            type: Number,
            txtDescr: `Number of slides (required for dynamic slides)`,
            default: _ => 0,
        },
        perspective: {
            name: 'perspective',
            type: Number,
            txtDescr: `Slides perspective position`,
            default: _ => 50,
        },
        countPage: {
            name: 'countPage',
            type: Number,
            txtDescr: `Number of slides displayed on each page`,
            default: _ => 5,
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['ltr', 'rtl', 'utd', 'dtu'],
            txtDescr: `Animation direction`,
            default: _ => 'ltr',
        },
        w: {
            name: 'w',
            type: Number,
            txtDescr: `Figure width (if =0, will not be set)`,
            default: _ => 0,
        },
        ws: {
            name: 'ws',
            type: Number,
            txtDescr: `Slide width displayed in center of carousel`,
            default: _ => 0,
        },
        hs: {
            name: 'hs',
            type: Number,
            txtDescr: `Slide height displayed in center of carousel`,
            default: _ => 0,
        },
        wc: {
            name: 'wc',
            type: Number,
            txtDescr: `Set arrows target area width in pixels`,
            txtEnable: 'Can be used only if "isArrows"',
            enabled: (v, sett) => sett.isArrows,
            default: _ => 50,
        },
        hc: {
            name: 'hc',
            type: Number,
            txtDescr: `Set arrows target area height in pixels`,
            txtEnable: 'Can be used only if "isArrows"',
            enabled: (v, sett) => sett.isArrows,
            default: _ => 50,
        },
        bd: {
            name: 'bd',
            type: Number,
            txtDescr: `Slide border size in pixels`,
            default: _ => 0,
        },
        bd: {
            name: 'bd',
            type: Number,
            txtDescr: `Slide border size in pixels`,
            default: _ => 0,
        },
        sp: {
            name: 'sp',
            type: Number,
            txtDescr: `Space between slides in pixels`,
            default: _ => 0,
        },
        scaling: {
            name: 'scaling',
            type: Number,
            txtDescr: `Slide inverse scaling`,
            default: _ => 300,
        },
        swipe: {
            name: 'swipe',
            type: Number,
            txtDescr: `Minimum distance in pixels to swipe before a slide advance is triggered`,
            default: _ => 10,
        },
        sl: {
            name: 'sl',
            type: Number,
            txtDescr: `Start slide index. First slide has 0 index`,
            default: _ => 0,
        },
    },
    computed: {
        isMulty() {
            return this.srcs_.length > 1
        },
        src_() {
            if(this.src)
                return this.src
            if(this.srcs && this.srcs.length >= 1)
                return this.srcs[0]
        },
        srcs_() {
            if(this.srcs.length)
                return this.srcs
            if(this.src)
                return [this.src]
            return []
        },
    },
    methods: {
        srcParse(src) {
            console.log('source: ', src)
            if(!src)
                return undefined
            //src = `pictures/${src}`
            return src
        },
    }
}
</script>

<template lang="pug">

div.dkbr-figure(
    :style=`{
        width: w ? w+'px' : undefined,
        height: 'auto',
        }`)
    div(
        v-if="isShow && !isMulty && src_")
        img.dkbr-figure__image(
            :style=`{
                width: ws ? ws+'px' : undefined,
                height: 'auto',
                }`
            :src="src_"
            :alt="alt")
    carousel-3d(
        v-if="isShow && isMulty"
        :autoplay="isAuto"
        :autoplayTimeout="autoDt"
        :autoplayHoverPause="autoPauseH"
        :perspective="perspective"
        :display="countPage"
        :loop="isRepeat"
        :animationSpeed="animDt"
        :dir='dir'
        :width="ws"
        :height="hs"
        :count="count"
        :border="bd"
        :space="sp"
        :disable3d="!is3D"
        :startIndex="sl"
        :controlsWidth="wc"
        :controlsHeight="hc"
        :inverseScaling="scaling"
        :minSwipeDistance="swipe"
        :clickable="isClick")
        slide(
            v-for="(s, i) in srcs_"
            :key="i"
            :index="i")
                div.dkbr-figure__image-wrapper
                    img.dkbr-figure__image(:src="srcParse(s)")
    slot
        div.dkbr-figure__text(
            v-if="txt"
            v-html="txt")
</template>

<style lang="sass">

@import '~@/sass/root.sass'

.dkbr-figure
    position: relative
    overflow: hidden
    +flex(column, $justify: flex-start, $align: center)
    &__image
        display: block
        max-width: 100%
        width: 100%
        height: auto
        border: 0 none
        +margin(0)
        &_multy
        &-wrapper
            width: 100%
            height: 100%
            +flex(row, nowrap, space-around, flex-start)
            background: white
    &__text
        display: inline-block
        order: 100
        +padding(10px 0 8px)
        //+font(base-bold)
        text-align: center
</style>



// WEBPACK FOOTER //
// src/figure/vue/Figure.vue